export { default as CoverImage } from './CoverImage';



// WEBPACK FOOTER //
// ./src/components/AdCard/CoverImage/index.ts